const apiUrl = process.env.REACT_APP_API_URL;
export const PostBbddValidar = async (id_user: string, id_exercici: string, id_practica?: string) => {
    try {
        const url = id_practica
            ? `${apiUrl}:8061/bbdd/users/${id_user}/exercici/${id_exercici}/validar?id_practica=${encodeURIComponent(id_practica)}`
            : `${apiUrl}:8061/bbdd/users/${id_user}/exercici/${id_exercici}/validar`;

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
